import React from "react";
import '../index.css';
import TopBar from "../components/SurveyTopbarAdmin";
import SideBar from "../components/SideBar";
import SurveyDashboard from "../surveys/SurveyDashboard";

function StudentsLayout(){
    return (
    <div className="d-flex flex-column" id="kt_app_root">
     <TopBar/>

      {/* Dashboard content container */}
      <div className="d-flex flex-grow-1">
       

        {/* Main Content Area */}
        <div className="flex-grow-1 p-4">
            <SurveyDashboard />
        </div>
      </div>
    </div>

    );
}

export default StudentsLayout;